import { AutomationNodeTypes } from 'hocs';
export const CONDITION_NODE_LABEL = 'Condition';
export const INIT_NODE_LABEL = 'Trigger';
export const getConditionHeadTitle = (type) => {
    if (type === AutomationNodeTypes.INIT) {
        return INIT_NODE_LABEL;
    }
    return CONDITION_NODE_LABEL;
};
export const getConditionHeadCaption = (type) => {
    if (type === AutomationNodeTypes.INIT) {
        return 'Specify the conditions your trigger must fulfill to initiate your automation.';
    }
    return 'Create some conditions to base further actions on.';
};
export const MATCH_BOOLEAN_DEFAULT_VALUE = {
    value: 'true',
    meta: { label: 'True' },
};
